<div
    class="relative shadow-md flex flex-col transition-all h-[190px] w-[200px] rounded-lg cursor-pointer"
    (click)="handleClick()"
    [ngClass]="{
        'hover:shadow-lg hover:scale-105': !editMode(),
        'border-4 border-warning': isMockBasketProduct(),
        'opacity-50': isDiscontinuedProduct()
    }"
    (mouseover)="updateHover(true)"
    (mouseleave)="updateHover(false)"
>
    <div
        class="absolute rounded-lg w-full h-full flex flex-col items-center justify-center bg-opacity-70 transition-all opacity-0"
        [ngClass]="{
            'bg-black': !markedForDelete() && !markedForAdd(),
            'bg-error': markedForDelete(),
            'bg-primary': markedForAdd(),
            'opacity-100': showEditModeButton() || markedForDelete() || markedForAdd()
        }"
    >
        <div class="relative w-[60px] h-[60px]">
            <button
                class="absolute top-0 bg-error border border-white flex justify-center items-center w-[60px] h-[60px] rounded-full opacity-0 transition-opacity"
                [ngClass]="{ 'opacity-100': showEditModeButton() && !markedForDelete() }"
            >
                <iota-icon icon="trash" class="text-white" size="2"></iota-icon>
            </button>
            <button
                class="absolute top-0 bg-primary border-2 border-white flex justify-center items-center w-[60px] h-[60px] rounded-full opacity-0 transition-opacity"
                [ngClass]="{ 'opacity-100': showEditModeButton() && markedForDelete() }"
            >
                <iota-icon icon="arrow-path" class="text-white" size="2"></iota-icon>
            </button>
        </div>
    </div>

    <div class="relative w-full h-[130px]">
        <img *ngIf="backgroundImageUrl()" class="w-full h-full rounded-t-lg object-cover" alt="Produkt-Bild" [src]="backgroundImageUrl()" />
        <div
            class="absolute bottom-0 w-full p-1 bg-warning bg-opacity-50 flex flex-col gap-1 text-sm font-bold"
            *ngIf="productSelection()?.overridesPricingOptions || productSelection()?.overridesAttributes"
        >
            <span *ngIf="productSelection()?.overridesPricingOptions" i18n>Overrides product option(s)</span>
            <span *ngIf="productSelection()?.overridesAttributes" i18n>Overrides product attribute(s)</span>
        </div>
    </div>

    <div
        class="flex flex-col h-[60px] gap-2 bg-base-100 rounded-b-md p-2"
        [ngClass]="{
            '!h-[52px]': isMockBasketProduct()
        }"
    >
        <div class="flex flex-row items-center w-full gap-1">
            <span class="font-bold max-w-[90%]">{{ labels().name | hyphenate }}</span>
        </div>
        <div class="flex flex-row items-center w-full gap-1" *ngIf="labels().subtitle">
            <span class="text-xs max-w-[90%]">{{ labels().subtitle | hyphenate }}</span>
        </div>
    </div>
</div>
